(function(){
'use strict';

angular.module('classy.frs').component('registrationCart', {
  template: '\n      <div class="registration-cart"\n        ng-class="{\'registration-cart__cart-height\': $ctrl.isPayment()}"\n        tabindex="0"\n        aria-label="Review your registration shopping cart.">\n\n        <header class="registration-cart__banner">\n          <h2 id="{{$ctrl.cartId}}" class="registration-cart__headline">Your Order</h2>\n        </header>\n\n        <div class="registration-cart__expired" ng-if="$ctrl.expiredVisible">\n          <registration-cart-alert\n            title="\'Your session timed out.\'"\n            description="\'Sorry about that, we had to release your registrations. Please make your selection again.\'"\n            dismiss-text="\'OK\'"\n            on-dismiss="$ctrl.hideExpired()"\n            primary-color="$ctrl.primaryColor"></registration-cart-alert>\n        </div>\n\n        <registration-cart-list\n          aria-labelledby="{{$ctrl.cartId}}"\n          class="registration-cart__items"\n          data-cart="$ctrl.cart"\n          data-color="$ctrl.primaryColor">\n        </registration-cart-list>\n\n        <div class="registration-cart__footer-promo preface" ng-if="$ctrl.hasAvailableCodes() && $ctrl.onTicketsState()">\n          <i class="fa fa-tag"></i>\n          Add a promo code on the next step\n        </div>\n\n        <div class="registration-cart__footer-promo"\n          ng-class="{\'show-form\': $ctrl.showPromo}"\n          ng-if="$ctrl.hasAvailableCodes() && !$ctrl.onTicketsState() && $ctrl.cart.saved.items.length && !$ctrl.cart.saved.promo_code_id">\n          <div class="registration-cart__promo-add" ng-show="!$ctrl.showPromo">\n            <a href class="registration-cart__promo-link"\n              ng-click="$ctrl.showPromo = true">\n              <i class="fa fa-tag" ng-style="{ \'color\': $ctrl.primaryColor }"></i>\n              Add Promo Code\n            </a>\n          </div>\n          <div class="registration-cart__promo-add" ng-show="$ctrl.showPromo">\n            <span>\n              <i class="fa fa-tag" ng-style="{ \'color\': $ctrl.primaryColor }"></i>\n              Adding promo code\n            </span>\n            <a href class="registration-cart__promo-cancel" ng-click="$ctrl.showPromo = false">Cancel</a>\n          </div>\n          <div class="registration-cart__promo" ng-show="$ctrl.showPromo">\n            <form name="promoCode"\n              sc-submit="$ctrl.applyPromoCode(this)"\n              use-status-banner="false"\n              data-wait-on-pending="true"\n              novalidate>\n              <promo-code-input-field\n                name="\'promo_code_input\'"\n                placeholder="\'Enter promo code\'"\n                model="$ctrl.promoCode.code"\n                getter-setter="true">\n              </promo-code-input-field>\n            </form>\n          </div>\n        </div>\n\n        <div class="registration-cart__footer-promo--added" ng-if="$ctrl.cart.saved.items.length && $ctrl.cart.saved.promo_code_id">\n          <div class="registration-cart__promo-add">\n            <div>\n              <i class="fa fa-tag" ng-style="{ \'color\': $ctrl.primaryColor }"></i>\n              {{ $ctrl.cart.promoCode.code }}\n              <p class="form__helper" ng-bind="$ctrl.friendlyDiscount"></p>\n            </div>\n            <a href class="registration-cart__promo-cancel" ng-click="$ctrl.removePromoCode()">Remove</a>\n          </div>\n        </div>\n\n        <div class="registration-cart__footer" ng-class="{ calculating: $ctrl.cart.isCalculating }">\n          <ng-include src="$ctrl.tpl(\'footer\')"></ng-include>\n        </div>\n\n        <div class="registration-cart__alerts" ng-if="$ctrl.alertVisible">\n          <registration-cart-alert\n            title="$ctrl.alertData.title"\n            description="$ctrl.alertData.description"\n            dismiss-text="$ctrl.alertData.dismissText"\n            on-dismiss="$ctrl.alertData.dismiss()"\n            exit-text="$ctrl.alertData.exitText"\n            on-exit="$ctrl.alertData.exit()"\n            primary-color="$ctrl.primaryColor"></registration-cart-alert>\n        </div>\n\n      </div>\n    ',
  bindings: {
    cart: '<',
    validityModel: '<',
    team: '<?',
    enableFrMinimums: '<',
    frMinimumExists: '&',
    cartId: '@?'
  },
  controller: ["$rootScope", "$q", "$scope", "$state", "$filter", "$window", "$timeout", "scCampaignsService", "scThemesService", "scFlowModalService", "scCartService", "registrationRoutes", "scPromoCodeService", "scBanner", "scCurrencyService", "scFeeOnTopService", "bugsnagClient", "scValidityService", function RegistrationCartCtrl($rootScope, $q, $scope, $state, $filter, $window, $timeout, scCampaignsService, scThemesService, scFlowModalService, scCartService, registrationRoutes, scPromoCodeService, scBanner, scCurrencyService, scFeeOnTopService, bugsnagClient, scValidityService) {
    var _this = this;

    var TICKETS_ROUTE = registrationRoutes.TICKETS_ROUTE,
        PAYMENT_ROUTE = registrationRoutes.PAYMENT_ROUTE,
        RECEIPT_ROUTE = registrationRoutes.RECEIPT_ROUTE,
        NEW_ATTENDEE_ROUTE = registrationRoutes.NEW_ATTENDEE_ROUTE,
        DONATION_ROUTE = registrationRoutes.DONATION_ROUTE;

    /* -------------------------------------------------------------------- *
     * Templates
     * -------------------------------------------------------------------- */

    this.tpl = function (slug) {
      return 'frs/registration/components/cart/inc/' + slug;
    };

    this.hasAvailableCodes = function () {
      return scPromoCodeService.hasAvailableCodesSync();
    };

    this.onTicketsState = function () {
      return $state.is(TICKETS_ROUTE);
    };

    this.isPayment = function () {
      return $state.is(PAYMENT_ROUTE);
    };

    this.showFrMinimumLeftToFundraise = function () {
      return _this.enableFrMinimums && !$state.is(TICKETS_ROUTE) && !$state.is(RECEIPT_ROUTE);
    };

    /* -------------------------------------------------------------------- *
     * Promo Codes
     * -------------------------------------------------------------------- */

    this.promoCode = {};
    var promoCodeId = null;
    var promoUrlParam = $state.params.promo;
    var itemCollection = [];
    this.$onInit = function () {
      promoCodeId = _.get(_this.cart, 'saved.promo_code_id', null);
      itemCollection = function itemCollection() {
        return _this.cart.isReserved ? _this.cart.current.items : _this.cart.stagedItems;
      };
    };
    /* 1. To check if promocode is not applied already on current state i.e. on NEW_ATTENDEE_ROUTE and DONATION_ROUTE.
       2. To check availability of promocode. If it is invalid or expired, banner will be displayed showing an error message. */
    $scope.$on('$locationChangeStart', function () {
      if (($state.current.name === NEW_ATTENDEE_ROUTE || $state.current.name === DONATION_ROUTE) && !_this.cart.saved.promo_code_id) {
        if (promoUrlParam) {
          scPromoCodeService.checkCodeAvailability({ promoCode: promoUrlParam }).then(function (_ref) {
            var state = _ref.state;

            if (state === 'invalid' || state === 'expired') {
              scBanner('Promo code ' + state, 'error');
              return $q.reject(state);
            }
            _this.applyPromoCode();
            return $q.resolve();
          });
        }
      }
    });
    this.$postLink = function () {
      if (promoCodeId) {
        _this.promoCode = _this.cart.promoCode;
        getDiscountOverviewText();
      } else {
        // trigger an async check against the active campaign to see whether it has
        // an updated value for whether any codes are active
        scPromoCodeService.hasAvailableCodesAsync();
      }
    };

    var currencySymbol = scCurrencyService.getCurrencySymbol(_.get(scCampaignsService, 'active.current.currency_code'));
    var ticketTypes = scCampaignsService.active.current.ticketTypes;

    var getDiscountOverviewText = function getDiscountOverviewText() {
      // Get a list of registration names the promo code applies to
      var discountedTickets = itemCollection().filter(function (_ref2) {
        var adjustment_amount = _ref2.adjustment_amount;
        return parseFloat(adjustment_amount) > 0;
      }).map(function (coll) {
        return _.find(ticketTypes, { id: coll.product_id }).name;
      });
      var registrationNames = _.uniq(discountedTickets).join(', ');
      var adjustmentAmount = $filter('number')(_this.promoCode.adjustment_amount, 0) || 0;
      // Build discount text
      var discountText = _this.promoCode.adjustment_type == 'percentage' ? adjustmentAmount + '%' : '' + currencySymbol + adjustmentAmount;
      _this.friendlyDiscount = discountText + ' off ' + registrationNames;
    };

    this.applyPromoCode = function () {
      var data = {
        promo_code: _this.promoCode.code || promoUrlParam,
        campaign_id: scCampaignsService.active.current.id
      };
      scFeeOnTopService.setIsCalculating('registration', true);
      _this.cart.saveData(data).then(function () {
        _this.promoCode = _this.cart.promoCode;
        scBanner('Promo code applied!', 'success');
        scFeeOnTopService.calculateFees({
          cartItems: _this.cart.isReserved ? _this.cart.current.items : _this.cart.stagedItems,
          type: 'registration',
          fot: _this.cart.registrationFeeOnTop,
          amount: _this.cart.itemsDiscountedSubtotal,
          frequency: _this.cart.current.donation_frequency
        });
        getDiscountOverviewText();
        // when a promo code is applied on the checkout page, we need to
        // refresh the validity model in order to activate the purchase
        // buttom if the registration becomes free
        var paymentValidyModel = scValidityService.get('registration').get('paymentForm');
        if (paymentValidyModel) {
          $timeout(function () {
            paymentValidyModel.update();
          });
        }
      }).catch(function (err) {
        scFeeOnTopService.setIsCalculating('registration', false);
        console.error(err); // eslint-disable-line no-console
        bugsnagClient.notify(err);
      });
    };

    $scope.cancelDelete = function () {
      scFlowModalService.close();
    };

    $scope.confirmDelete = function () {
      var data = {
        promo_code_id: null
      };
      _this.cart.saveData(data).then(function () {
        scPromoCodeService.hasAvailableCodesAsync();
        scBanner('Promo code removed!', 'success');
        if (promoUrlParam) {
          $state.go($state.$current.name, { promo: null }, { notify: false });
        }
        scFeeOnTopService.calculateFees({
          cartItems: _this.cart.isReserved ? _this.cart.current.items : _this.cart.stagedItems,
          type: 'registration',
          fot: _this.cart.registrationFeeOnTop,
          amount: _this.cart.itemsDiscountedSubtotal,
          frequency: _this.cart.current.donation_frequency
        });
        if (_this.promoCode) {
          _this.promoCode.code = null;
          _this.showPromo = false;
          promoUrlParam = null;
        }
      }).catch(function () {
        scBanner('Oops! Unable to remove promo code. Please try again.', 'error');
      }).finally(function () {
        scFlowModalService.close();
      });
    };

    this.displayTotal = function () {
      return _this.cart.total !== 0 || !_this.cart.stagedItems.length ? $filter('currency')(_this.cart.total, '$', 2) : 'Free';
    };

    this.getFrMinimumInfoFunc = function () {
      var frMinimumInfo = scCartService.getFrMinimumInfo();

      _this.frMinimumExists({ exists: frMinimumInfo.count > 0 });
      return frMinimumInfo;
    };

    this.removePromoCode = function () {
      scFlowModalService.open({
        template: '\n            <modal-frame>\n              <modal-title>Remove Code</modal-title>\n              <div class="registration-cart__modal">\n                <p class="registration-cart__modal__subheader">Remove the {{ $ctrl.promoCode.code }} discount from registrations?</p>\n                <div class="registration-cart__modal-btns">\n                  <div class="registration-cart__modal--cancel"\n                  data-ng-click="cancelDelete()"\n                  _spec="promoCodeCancel">Cancel</div>\n                  <div class="registration-cart__modal--confirm"\n                  data-ng-click="confirmDelete()"\n                  ng-style="{ \'background-color\': $ctrl.primaryColor }">Remove</div>\n                </div>\n              </div>\n            </modal-frame>\n          ',
        context: $scope
      });
    };

    /* -------------------------------------------------------------------- *
     * Style
     * -------------------------------------------------------------------- */

    this.primaryColor = scThemesService.active.current.styles.primaryColor;

    /* -------------------------------------------------------------------- *
     * Alerts
     * -------------------------------------------------------------------- */

    this.alertVisible = false;
    this.alertData = {};

    // eslint-disable-next-line no-unused-vars
    $rootScope.$on('registrationAlert', function (event, open, alertData) {
      // if mobile view, use scFlowModal to display alerts
      var isMobile = void 0;
      if (Modernizr.prefixed('matchMedia', window)) {
        isMobile = window.matchMedia('(max-width: 1024px)').matches;
      } else {
        isMobile = angular.element($window).width() <= 1025 && angular.element($window).width() >= 768;
      }

      if (isMobile) {
        $scope.alertData = alertData;
        $scope.primaryColor = _this.primaryColor;

        if (!alertData) {
          scFlowModalService.close();
        } else {
          scFlowModalService.open({
            id: 'rwf_checkout_alert',
            context: $scope,
            template: '\n                <registration-cart-alert\n                title="alertData.title"\n                description="alertData.description"\n                dismiss-text="alertData.dismissText"\n                on-dismiss="alertData.dismiss()"\n                exit-text="alertData.exitText"\n                on-exit="alertData.exit()"\n                primary-color="primaryColor"\n                mobile="true">\n                </registration-cart-alert>\n              '
          }, {
            transitionWhitelist: [TICKETS_ROUTE]
          });
        }
      } else {
        _this.alertVisible = open;
        _this.alertData = alertData;
      }
    });
  }]
});
})();